import { render, staticRenderFns } from "./Stocks.vue?vue&type=template&id=5ba5e283&scoped=true"
import script from "./Stocks.vue?vue&type=script&lang=js"
export * from "./Stocks.vue?vue&type=script&lang=js"
import style0 from "./Stocks.vue?vue&type=style&index=0&id=5ba5e283&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba5e283",
  null
  
)

export default component.exports